import MuiPopover, { type PopoverProps as MuiPopoverProps } from '@mui/material/Popover'
import MuiTooltip, {
  type TooltipProps as MuiTooltipProps,
  tooltipClasses as MuiTooltipClasses,
} from '@mui/material/Tooltip'
import MuiTypography, { type TypographyProps as MuiTypographyProps } from '@mui/material/Typography'
import MuiDialogTitle, { type DialogTitleProps as MuiDialogTitleProps } from '@mui/material/DialogTitle'
import MuiDialogContent, { type DialogContentProps as MuiDialogContentProps } from '@mui/material/DialogContent'
import MuiPopper, { type PopperProps as MuiPopperProps } from '@mui/material/Popper'
import MuiAlert, { type AlertProps as MuiAlertProps } from '@mui/material/Alert'
import MuiSnackbar, { type SnackbarProps as MuiSnackbarProps } from '@mui/material/Snackbar'
import MuiSkeleton, { type SkeletonProps as MuiSkeletonProps } from '@mui/material/Skeleton'
import MuiAccordion, { type AccordionProps as MuiAccordionProps } from '@mui/material/Accordion'
import MuiAccordionSummary, {
  type AccordionSummaryProps as MuiAccordionSummaryProps,
} from '@mui/material/AccordionSummary'
import MuiAccordionDetails, {
  type AccordionDetailsProps as MuiAccordionDetailsProps,
} from '@mui/material/AccordionDetails'
import MuiDrawer, { type DrawerProps as MuiDrawerProps } from '@mui/material/Drawer'

//* POPOVER
export const Popover = MuiPopover
export type PopoverProps = MuiPopoverProps

//* TOOLTIP
export const Tooltip = MuiTooltip
export type TooltipProps = MuiTooltipProps
export const tooltipClasses = MuiTooltipClasses

//* TYPOGRAPHY
export const Typography = MuiTypography
export type TypographyProps = MuiTypographyProps

//* DIALOG TITLE
export const DialogTitle = MuiDialogTitle
export type DialogTitleProps = MuiDialogTitleProps

//* DIALOG CONTENT
export const DialogContent = MuiDialogContent
export type DialogContentProps = MuiDialogContentProps

//* POPPER
export const Popper = MuiPopper
export type PopperProps = MuiPopperProps

//* ALERT
export const Alert = MuiAlert
export type AlertProps = MuiAlertProps

//* SNACKBAR
export const Snackbar = MuiSnackbar
export type SnackbarProps = MuiSnackbarProps

//* SKELETON
export const Skeleton = MuiSkeleton
export type SkeletonProps = MuiSkeletonProps

//* ACCORDION
export const Accordion = MuiAccordion
export type AccordionProps = MuiAccordionProps

//* ACCORDION SUMMARY
export const AccordionSummary = MuiAccordionSummary
export type AccordionSummaryProps = MuiAccordionSummaryProps

//* ACCORDION DETAILS
export const AccordionDetails = MuiAccordionDetails
export type AccordionDetailsProps = MuiAccordionDetailsProps

//* DRAWER
export const Drawer = MuiDrawer
export type DrawerProps = MuiDrawerProps
